import HistoryDetailList from "./components/HistoryDetailList";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Button } from "antd-mobile";
import instance from "../../../../util/axios";

export default function CompletionListDetail() {
  const history = useHistory();
  const params = useParams<{
    fillingId: string;
  }>();
  const [isCutting, setIsCutting] = useState<boolean>(false);

  const descriptionNoCutting = [
    {
      fieldName: "createTime",
      fieldShowName: "时间",
      width: 120,
    },
    {
      fieldName: "serialNumber",
      fieldShowName: "批号",
      width: 120,
    },
    {
      fieldName: "dealerId",
      fieldShowName: "客户名称",
      width: 120,
      inputType: 6,
      dictionary: "rad_dealer",
    },
    {
      fieldName: "radId",
      fieldShowName: "产品",
      width: 120,
      inputType: 6,
      dictionary: "rad_sku",
    },
    {
      fieldName: "custom_text_1",
      fieldShowName: "规格",
      width: 120,
    },
    {
      fieldName: "custom_text_2",
      fieldShowName: "排档方式",
      width: 120,
    },
    {
      fieldName: "color",
      fieldShowName: "表面处理",
      width: 120,
      inputType: 6,
      dictionary: "dict_rad_color",
    },
    {
      fieldName: "formulaName",
      fieldShowName: "图号",
      width: 120,
    },
    {
      fieldName: "completeTime",
      fieldShowName: "完成日期",
      width: 120,
    },
    {
      fieldName: "orderDate",
      fieldShowName: "订单交期",
      width: 120,
    },
    {
      fieldName: "produceQuantity",
      fieldShowName: "数量",
      width: 120,
    },
    {
      fieldName: "amount",
      fieldShowName: "转移数量",
      width: 120,
    } 
  ];
  return (
    <>
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div style={{ flex: 1, overflowY: "auto" }}>
          <HistoryDetailList
            url={`/erp/sku/workshop/getCompletionTransferFillingList?fillingId=${params?.fillingId}`}
            sorter={{ field: "createTime", order: "descend" }}
            descriptions={descriptionNoCutting}
          />
        </div>
        <Button
          style={{ width: "100%", zIndex: 99 }}
          type="primary"
          onClick={() => {
            history.push(
              `/erp/completion/transfer/HistoryNewIndex/${params?.fillingId}`
            );
          }}
        >
          再次填报
        </Button>
      </div>
    </>
  );
}
